import classNames from 'classnames';

export enum DotColorEnum {
  red,
  green,
}

export type DotColor = DotColorEnum.red | DotColorEnum.green;

export const TyDot = ({ dotColor }: { dotColor: DotColor }) => {
  return (
    <div
      className={classNames('rounded-full', 'h-[10px]', 'w-[10px]', 'flex', {
        'bg-red-600': dotColor === DotColorEnum.red,
        'bg-primary-400': dotColor === DotColorEnum.green,
      })}
    >
      <div className="bg-white w-[4px] h-[4px] rounded-full m-auto"></div>
    </div>
  );
};
